import axios from 'axios';
import { SIGN_IN, SIGN_UP } from './route';
import { toast } from 'react-toastify';

const authApi = {
  request: async (method, url, data = null) => {
    return axios({
      method,
      url,
      data,
      headers: { Authorization: `Bearer ${localStorage.getItem('authToken')}` },
    })
      .then(async (response) => {
        return response.data;
      })
      .catch((error) => {
        console.log(error, 'why?')
        if (error.code === 'ERR_NETWORK') {
          toast.error('unable to access server');
        }
        if (error.response && error.response.status === 401) {
          localStorage.removeItem('authToken');
          window.location.href = SIGN_IN;
        }
        if (
          error.response.status === 404 &&
          error.response.data.message === 'Invalid Account'
        ) {
          window.location.href = SIGN_UP;
          toast.error(error.response.data.message);
        }
        toast.error(error.response.data.message);
        return error.response.data;
      });
  },
  get: (url) => authApi.request('get', url),
  post: (url, data) => authApi.request('post', url, data),
  put: (url, data) => authApi.request('put', url, data),
  delete: (url) => authApi.request('delete', url),
};

export default authApi;
